<template>
  <div class="page_rosterEmpEdit">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>雇员</el-breadcrumb-item>
          <el-breadcrumb-item>面试入职流程</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/empRosterPerson', query: { active: '花名册列表' } }">花名册列表</el-breadcrumb-item>
          <el-breadcrumb-item>{{ type=='entry' ? '入职登记' : type=='entryHandel' ? '入职' : '编辑' }}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="ftabs">
        <!-- <el-tabs v-model="activeName" @tab-click="changeTab" class="s_tabs_box">
          <el-tab-pane label="详情" name="0"></el-tab-pane>
          <el-tab-pane label="编辑" name="1"></el-tab-pane>
        </el-tabs> -->
        <div class="dtlBox" v-if="isOver">
          <el-form :model="dtlForm" ref="dtlForm" :rules="rule" :inline="true" label-width="130px">
            <div class="Reititle"><span class="titleLine">|</span> 岗位信息
            </div>
            <el-form-item label="服务中心:">
              <el-input v-model="dtlForm.StrSrvCent" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="项目名称:" prop="StrObjName">
              <el-select v-model="dtlForm.StrObjName" placeholder="" filterable size="small" style="width: 180px;" @change="wxappgetjoblist">
                <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="子项目:">
              <el-input v-model="dtlForm.SubProject" clearable size="small" style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="客户单位全称:"  prop="CustomerName">
              <el-input v-model="dtlForm.CustomerName" clearable size="small" style="width: 180px;"></el-input>
            </el-form-item>
            <el-form-item label="商保岗位类别:"  prop="InsureJobClass">
              <el-select v-model="dtlForm.InsureJobClass" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="1-4类"></el-option>
                <el-option value="5类"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="项目类别:">
              <el-select v-model="dtlForm.StrProjectType" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="岗位外包"></el-option>
                <el-option value="派遣"></el-option>
                <el-option value="代理"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="业务立项部门:">
              <el-input v-model="dtlForm.StrObjInstName" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="负责客服:">
              <el-select v-model="dtlForm.StrUserName" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option v-for="(item, index) in memberList" :key="index" :label="item.Username" :value="item.Username">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="部门:">
              <el-input v-model="dtlForm.StrDepName" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="商保岗位:">
              <el-input v-model="dtlForm.InsureJob" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="合同岗位:">
              <el-input v-model="dtlForm.SignJob" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="岗位:">
              <el-input v-model="dtlForm.StrJobInf" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="招聘岗位:">
              <el-select v-model="dtlForm.StrOutsideCity" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option v-for="(item, index) in JobList" :value="item.CustomerJobName" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="招聘岗位类别:">
              <el-select v-model="dtlForm.StrInCity" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="餐饮及服务"></el-option>
                <el-option value="技工普工"></el-option>
                <el-option value="零售类"></el-option>
                <el-option value="物流仓储"></el-option>
                <el-option value="办公人员"></el-option>
                <el-option value="代理"></el-option>
                <el-option value="灵活用工"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="临时工:">
              <el-select v-model="dtlForm.StrOther" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="是"></el-option>
                <el-option value="否"></el-option>
              </el-select>
            </el-form-item>
            <div class="Reititle"><span class="titleLine">|</span> 员工基础信息
            </div>
            <el-form-item label="姓名:" prop="StrEmpName">
              <el-input v-model="dtlForm.StrEmpName" :disabled="type=='edit' ? true : false" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="身份证号码:" prop="StrIdCard">
              <el-input v-model="dtlForm.StrIdCard" :disabled="type=='edit' ? true : false" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="身份证有效终止日期:">
              <el-date-picker v-model="dtlForm.DtIcCareEdate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="籍贯:">
              <el-input v-model="dtlForm.StrNativePlace" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="户籍地址:">
              <el-input v-model="dtlForm.StrNativeAddr" size="small" style="width: 500px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="联系方式:" prop="StrPhoneNum">
              <el-input v-model="dtlForm.StrPhoneNum" :disabled="type=='edit' ? true : false" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="档案号:">
              <el-input v-model="dtlForm.StrFileNo" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="用工之日:" prop="DtEntryBdate">
              <el-date-picker v-model="dtlForm.DtEntryBdate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="试用期到期日期:">
              <el-date-picker v-model="dtlForm.DtProbationEdate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="婚姻状况:">
              <el-select v-model="dtlForm.MarriageState" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="已婚"></el-option>
                <el-option value="未婚"></el-option>
                <el-option value="离异"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="民族:">
              <el-select v-model="dtlForm.StrNationClass" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option v-for="item in nationList" :key="item.Id" :label="item.Name" :value="item.Name"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="户粮:">
              <el-select v-model="dtlForm.StrCityzenType" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="农"></el-option>
                <el-option value="居"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="紧急联系人:">
              <el-input v-model="dtlForm.StrContName" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="紧急联系方式:">
              <el-input v-model="dtlForm.StrContTel" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="政治面貌:">
              <el-select v-model="dtlForm.StrPolitical" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="党员"></el-option>
                <el-option value="团员"></el-option>
                <el-option value="群众"></el-option>
                <el-option value="民主党派"></el-option>
                <el-option value="其他"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="现住地址:">
              <el-input v-model="dtlForm.StrAddr" size="small" style="width: 500px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="银行:">
              <el-input v-model="dtlForm.StrBankName" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="发证机关:">
              <el-input v-model="dtlForm.IdCardIssUing" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="银行卡号:">
              <el-input v-model="dtlForm.StrBankCard" size="small" style="width: 500px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="计提:">
              <el-input v-model="dtlForm.StrWithdrawal" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="医保卡号:">
              <el-input v-model="dtlForm.StrMedicalCard" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="是否需要体检:">
              <el-select v-model="dtlForm.IsCheckUp" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="是"></el-option>
                <el-option value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="体检类型:">
              <el-select v-model="dtlForm.StrPetype" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="常规体检"></el-option>
                <el-option value="职业病体检"></el-option>
                <el-option value="无要求"></el-option>
                <el-option value="健康证"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="体检结果:">
              <el-select v-model="dtlForm.StrPeres" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="正常"></el-option>
                <el-option value="异常"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="劳动合同起始时间:">
              <el-date-picker v-model="dtlForm.DtContractBtime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="劳动合同到期时间:">
              <el-date-picker v-model="dtlForm.DtContractTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="签定合同次数:">
              <el-input type="number" v-model="dtlForm.IntContractNum" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="合同（协议）类型:">
              <el-select v-model="dtlForm.StrContractType" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="劳动合同"></el-option>
                <el-option value="兼职协议"></el-option>
                <el-option value="实习管理协议"></el-option>
                <el-option value="退休返聘协议"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="司龄:">
              <el-input type="number" v-model="dtlForm.CompanyAge" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="在/离职状态:" prop="StrWorkState">
              <el-select v-model="dtlForm.StrWorkState" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="在职"></el-option>
                <el-option value="离职"></el-option>
                <el-option value="自离"></el-option>
                <el-option value="离职转正"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="离职日期:" :prop="dtlForm.StrWorkState && dtlForm.StrWorkState != '在职' ? 'DtDepartureDate' : ''">
              <el-date-picker v-model="dtlForm.DtDepartureDate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="实际离职日期:">
              <el-date-picker v-model="dtlForm.DtRealDepartureDate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="离职原因:">
              <el-input v-model="dtlForm.OutCompanyReason" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <!-- <el-form-item label="社招推荐人:">
              <el-input v-model="dtlForm.Sctjr" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="公司渠道:">
              <el-input v-model="dtlForm.Gsqd" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="公司渠道推荐人:">
              <el-input v-model="dtlForm.Gsqdtjr" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="外部渠道:">
              <el-input v-model="dtlForm.Wbqd" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="外部渠道推荐人:">
              <el-input v-model="dtlForm.Wbqdtjr" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item> -->
            <!-- <el-form-item label="其他情况:">
              <el-input v-model="dtlForm.Qtqk" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item> -->
            <el-form-item label="推荐人:">
              <el-select v-model="dtlForm.PushName" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="社招推荐人"></el-option>
                <el-option value="公司渠道"></el-option>
                <el-option value="供应商"></el-option>
                <el-option value="网招"></el-option>
                <el-option value="客服部"></el-option>
                <el-option value="项目部"></el-option>
                <el-option value="内荐"></el-option>
                <el-option value="其他情况"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="推荐日期:">
              <el-date-picker v-model="dtlForm.PushTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="推荐人备注:">
              <el-input v-model="dtlForm.PushRemark" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="备注:">
              <el-input v-model="dtlForm.StrRemark" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="是否黑名单:">
              <el-select v-model="dtlForm.StrBlacklist" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="是"></el-option>
                <el-option value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="报销时间:">
              <el-date-picker v-model="dtlForm.ReimbursementDate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="黑名单原因:">
              <el-input v-model="dtlForm.StrBlacklistReason" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <div class="Reititle"><span class="titleLine">|</span> 教育经历
            </div>
            <el-form-item label="教育程度:">
              <el-select v-model="dtlForm.StrEduLv" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="博士"></el-option>
                <el-option value="硕士"></el-option>
                <el-option value="本科"></el-option>
                <el-option value="大专"></el-option>
                <el-option value="中专"></el-option>
                <el-option value="高中"></el-option>
                <el-option value="初中及以下"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="是否全日制:">
              <el-select v-model="dtlForm.IsFullTime" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="是"></el-option>
                <el-option value="否"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所学专业:">
              <el-input v-model="dtlForm.FinishMajor" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="毕业时间:">
              <el-date-picker v-model="dtlForm.FinishSchoolTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="毕业院校:">
              <el-input v-model="dtlForm.FinishSchoolName" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="最高学历学校:">
              <el-input v-model="dtlForm.SchoolName" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="最高学历专业:">
              <el-input v-model="dtlForm.Major" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="最高学历入学时间:">
              <el-date-picker v-model="dtlForm.InSchoolTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="最高学历毕业时间:">
              <el-date-picker v-model="dtlForm.OutSchoolTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <div class="flex sb">
              <div class="Reititle"><span class="titleLine">|</span> 合同签约记录
              </div>
              <div>
                <el-button type="primary" size="small" @click="addContract()">添加合同信息</el-button>
              </div>
            </div>
            <!-- <el-form-item label="首次合同/协议签订开始时间:">
              <el-date-picker v-model="dtlForm.DtContractBtime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="首次合同/协议签订结束时间:">
              <el-date-picker v-model="dtlForm.DtContractTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item> -->
            <el-table :data="ContractJson" border class="doc_table" style="width:100%;margin-bottom: 20px;">
              <el-table-column align="center" show-overflow-tooltip label="次数" prop="times" min-width="80">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="类型" prop="type" min-width="100">
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="用工之日" prop="DtEntryBdate" min-width="100">
                <template slot-scope="{row}">{{ row.DtEntryBdate ? row.DtEntryBdate.split('T')[0] : '' }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="合同开始时间" prop="DtContractBtime" min-width="100">
                <template slot-scope="{row}">{{ row.DtContractBtime ? row.DtContractBtime.split('T')[0] : ''
                  }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="合同结束时间" prop="DtContractTime" min-width="100">
                <template slot-scope="{row}">{{ row.DtContractTime ? row.DtContractTime.split('T')[0] : '' }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="试用期结束时间" prop="DtProbationEdate" min-width="100">
                <template slot-scope="{row}">{{ row.DtProbationEdate ? row.DtProbationEdate.split('T')[0] : ''
                  }}</template>
              </el-table-column>
              <el-table-column align="center" show-overflow-tooltip label="附件" prop="fileUrl" min-width="100">
                <template slot-scope="{row}">
                  <div v-if="row.fileUrl!=null && row.fileUrl.length>0">
                    <div v-for="(item,index) in row.fileUrl" :key="index" class="blueName cp" @click="down(item)">{{ item.name }}</div>
                  </div>
                </template>
              </el-table-column>
              <el-table-column align="center" label="操作" fixed="right" min-width="80px">
                <template slot-scope="{row,$index}">
                  <div class="injuryTabBtn">
                    <el-button type="text" size="small" @click="edit(row,$index)">修改</el-button>
                    <el-button type="text" size="small" @click="del($index)">删除</el-button>
                  </div>
                </template>
              </el-table-column>
            </el-table>

            <div class="blueName cp" @click="addEleSign()" style="margin-left: 30px;margin-bottom: 20px;">
              添加电子签约信息
            </div>

            <div class="Reititle"><span class="titleLine">|</span> 工伤/三期等人员状态
            </div>
            <!-- <el-form-item label="人员状态:">
              <el-select v-model="dtlForm.StrWorkStateStrEmpUsrStatus" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="在职"></el-option>
                <el-option value="再次入职"></el-option>
                <el-option value="三期"></el-option>
                <el-option value="工伤期"></el-option>
                <el-option value="调岗"></el-option>
                <el-option value="待岗"></el-option>
                <el-option value="医疗期"></el-option>
                <el-option value="其他"></el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="工伤期开始时间:">
              <el-date-picker v-model="dtlForm.DtInjuryBdate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="工伤期结束时间:">
              <el-date-picker v-model="dtlForm.DtInjuryEndDate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="伤残等级:">
              <el-select v-model="dtlForm.StrDisabilityLevel" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="一级"></el-option>
                <el-option value="二级"></el-option>
                <el-option value="三级"></el-option>
                <el-option value="四级"></el-option>
                <el-option value="五级"></el-option>
                <el-option value="六级"></el-option>
                <el-option value="七级"></el-option>
                <el-option value="八级"></el-option>
                <el-option value="九级"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="医疗期开始时间:">
              <el-date-picker v-model="dtlForm.MedicineBeginDate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="医疗期结束时间:">
              <el-date-picker v-model="dtlForm.MedicineEndDate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="三期开始时间:">
              <el-date-picker v-model="dtlForm.ThreeBeginTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="三期结束时间:">
              <el-date-picker v-model="dtlForm.ThreeEndTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <div class="Reititle"><span class="titleLine">|</span> 保险信息
            </div>
            <el-form-item label="参保种类:">
              <!-- <el-select v-model="dtlForm.StrInsuranceType" size="small" style="width: 180px;" placeholder="" filterable>
                <el-option value="基本险"></el-option>
                <el-option value="大商保"></el-option>
                <el-option value="小商保"></el-option>
                <el-option value="大小商保"></el-option>
              </el-select> -->
              <el-input v-model="dtlForm.StrInsuranceType" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="参保日期:">
              <el-date-picker v-model="dtlForm.DtInsuranceDate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="社保参保账户:">
              <el-input v-model="dtlForm.SocialInsuranceAccount" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="公积金参保账户:">
              <el-input v-model="dtlForm.ProvidentFundAccount" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="社保基数:">
              <el-input v-model="dtlForm.SocialInsuranceNumber" type="number" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="公积金基数:">
              <el-input v-model="dtlForm.ProvidentFundNumber" type="number" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="公积金缴纳比例:">
              <el-input v-model="dtlForm.ProvidentFundRate" type="number" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="最低工资:">
              <el-input v-model="dtlForm.LowestSalary" type="number" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="处理进度:">
              <el-input v-model="dtlForm.ProcessingPace" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="理赔资料:">
              <el-input v-model="dtlForm.CSInfo" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="理赔进度:">
              <el-input v-model="dtlForm.CSPace" size="small" style="width: 180px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="开票公司全称:" prop="StrBlCmp">
              <el-select v-model="dtlForm.StrBlCmp" placeholder="" filterable size="small" style="width: 500px;">
                <el-option v-for="(item, index) in legList" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="开票公司全称(对内):">
              <el-select v-model="dtlForm.InvoiceCompanyNameInSide" placeholder="" filterable size="small" style="width: 500px;">
                <el-option v-for="(item, index) in legList" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="发薪公司全称:">
              <el-select v-model="dtlForm.SalaryCompanyName" placeholder="" filterable size="small" style="width: 500px;">
                <el-option v-for="(item, index) in legList" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="合同公司全称:">
              <el-select v-model="dtlForm.ContractCompanyName" placeholder="" filterable size="small" style="width: 500px;">
                <el-option v-for="(item, index) in legList" :value="item.value" :key="index"></el-option>
              </el-select>
            </el-form-item>
            <div class="blueName cp" @click="addInsure()" style="margin-left: 30px;margin-bottom: 20px;">
              添加参保信息
            </div>
            <div class="Reititle"><span class="titleLine">|</span> 附件信息
            </div>
            <el-form-item label="身份证正面照:">
              <el-upload class="avatar-uploader" action="" :auto-upload="false" :show-file-list="false" :on-change="(file, fileList) => { handleAvatarSuccess(file, fileList, 'FrontCardIdUrl',0) }">
                <img v-if="dtlForm.FrontCardIdUrl" :src="imgHead + dtlForm.FrontCardIdUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-button type="success" @click="orcType(dtlForm.FrontCardIdUrl,0)" size="small">识别</el-button>
            </el-form-item>
            <el-form-item label="身份证背面照:">
              <el-upload class="avatar-uploader" action="" :auto-upload="false" :show-file-list="false" :on-change="(file, fileList) => { handleAvatarSuccess(file, fileList, 'VersoCardIdUrl',4) }">
                <img v-if="dtlForm.VersoCardIdUrl" :src="imgHead + dtlForm.VersoCardIdUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-button type="success" @click="orcType(dtlForm.VersoCardIdUrl,4)" size="small">识别</el-button>
            </el-form-item>
            <el-form-item label="银行卡照片:">
              <el-upload class="avatar-uploader" action="" :auto-upload="false" :show-file-list="false" :on-change="(file, fileList) => { handleAvatarSuccess(file, fileList, 'BankCardUrl',1) }">
                <img v-if="dtlForm.BankCardUrl" :src="imgHead + dtlForm.BankCardUrl" class="avatar">
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
              <el-button type="success" @click="orcType(dtlForm.BankCardUrl,1)" size="small">识别</el-button>
            </el-form-item>
            <el-form-item label="其他附件:">
              <el-upload class="upload-demo" ref="file" action="#" :on-change="success_handle" :auto-upload="false" :limit="5" :on-remove="handleFileRemove" :on-exceed="handleExceed" :file-list="contractList">
                <el-button size="small" type="primary">上传其他附件</el-button>
              </el-upload>
            </el-form-item>

            <div class="Reititle"><span class="titleLine">|</span> 备注
            </div>
            <div v-if="remarkInfo">
              <el-form-item :label="'备注' + i + ':'" v-for="i in 20" :key="i">
                <el-input v-model="remarkInfo['备注'+i]" size="small" style="width: 180px;" clearable></el-input>
              </el-form-item>
            </div>
          </el-form>
          <div class="btn_box">
            <el-button type="success" @click="submit()" :loading="isBtnLoading">保存</el-button>
            <el-button @click="backHandle">返 回</el-button>
          </div>
        </div>
        <div v-if="!isOver" v-loading="loading" style="height: 300px;"></div>
      </div>
    </div>
    <el-dialog :title="type == 'add' ? '添加合同信息' : '修改合同信息'" :visible.sync="showAddContract" width="750px">
      <el-form :model="itemInfo" :inline="true" :rules="rule" ref="itemInfo" class="re_down_form" label-width="120px" prop="times">
        <el-form-item label="次数:" prop="times">
          <el-select v-model="itemInfo.times" size="small" style="width: 180px;" placeholder="" filterable>
            <el-option v-for="item in 10" :key="item" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同/协议类型:" prop="type">
          <el-select v-model="itemInfo.type" size="small" style="width: 180px;" placeholder="" filterable>
            <el-option value="劳动合同"></el-option>
            <el-option value="兼职协议"></el-option>
            <el-option value="实习管理协议"></el-option>
            <el-option value="退休返聘协议"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用工之日:" prop="DtEntryBdate">
          <el-date-picker v-model="itemInfo.DtEntryBdate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="试用期结束时间:" prop="DtProbationEdate">
          <el-date-picker v-model="itemInfo.DtProbationEdate" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同开始时间:" prop="DtContractBtime">
          <el-date-picker v-model="itemInfo.DtContractBtime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="合同结束时间:" prop="DtContractTime">
          <el-date-picker v-model="itemInfo.DtContractTime" type="date" value-format="yyyy-MM-dd" size="small" style="width: 180px;">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="附件:">
          <el-upload class="upload-demo" ref="file" accept=".pdf" action="#" :on-change="success_handle2" :auto-upload="false" :limit="5" :on-remove="handleFileRemove2" :on-exceed="handleExceed2" :file-list="fileList">
            <el-button size="small" type="primary">上传附件</el-button>
          </el-upload>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showAddContract = false" size="small">取消</el-button>
        <el-button type="primary" @click="confirmAddContract" size="small" :loading="isBtnLoading">确定</el-button>
      </span>
    </el-dialog>

    <!-- 报增弹窗 -->
    <el-dialog title="报增" :visible.sync="showDeclare" width="980px">
      <div class="declareForm">
        <el-form :model="declareForm" :rules="declareRules" :inline="true" ref="declareForm" label-width="130px">
          <el-form-item label="险种名称">
            <el-select v-model="declareForm.Insurance.InsuranceId" placeholder="" size="small" clearable filterable style="width:300px" @change="changeInsuranceId">
              <el-option v-for="(item,index) in insureList" :key="index" :label="item.Bntype" :value="item.Id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="可参保保单" prop="policy">
            <el-select v-model="policy" placeholder="" value-key="Id" size="small" clearable filterable style="width:300px" @change="policyChange">
              <el-option v-for="(item, index) in policyList" :key="index" :label="item.CoverStartTime.split('T')[0] + ' ~ ' + item.CoverEndTime.split('T')[0]" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="保障期限">
            <div class=" flex aic">
              <el-date-picker type="date" placeholder="" v-model="declareForm.Insurance.InsuranceStartTime" value-format="yyyy-MM-dd" style="width:143px" size="small" disabled></el-date-picker>
              <div style="margin: 0 5px;">-</div>
              <el-date-picker type="date" placeholder="" v-model="declareForm.Insurance.InsuranceEndTime" value-format="yyyy-MM-dd" style="width:143px" size="small" disabled></el-date-picker>
            </div>
          </el-form-item>
          <el-form-item label="项目名称" prop="Insurance.Projectid">
            <el-select v-model="proName" placeholder="" value-key="Projectid" size="small" clearable filterable style="width:300px" @change="proChange">
              <el-option v-for="(item, index) in projectList" :key="index" :label="item.StrprojectName" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="被保险人姓名" prop="userList[0].MainlinsuredName">
            <el-input v-model="declareForm.userList[0].MainlinsuredName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="证件类型" prop="userList[0].Idtype">
            <el-select v-model="declareForm.userList[0].Idtype" placeholder="" size="small" clearable filterable style="width:300px">
              <el-option value="身份证"></el-option>
              <el-option value="护照"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="证件号码" prop="userList[0].MainlinsuredCardId">
            <el-input v-model="declareForm.userList[0].MainlinsuredCardId" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="被保险人手机" prop="userList[0].MainlinsuredPhone">
            <el-input v-model="declareForm.userList[0].MainlinsuredPhone" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="岗位" prop="userList[0].JobName">
            <template #label>
              <span>岗位
                <el-tooltip placement="top" effect="light" v-if="JobNameTip">
                  <div slot="content" class="JobClasssTip cp" @click="getTipDtl">
                    <div v-for="(item,index) in JobNameTip" :key="index">{{ item }}</div>
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-input v-model="declareForm.userList[0].JobName" style="width:300px" size="small"></el-input>
          </el-form-item>
          <el-form-item label="职业类别" prop="userList[0].JobClasss">
            <template #label>
              <span>职业类别
                <el-tooltip :content="JobClasssTip" placement="top" effect="light" v-if="JobClasssTip">
                  <div slot="content" class="JobClasssTip cp" @click="getTipDtl">
                    {{ JobClasssTip }}
                  </div>
                  <i class="el-icon-question cp"></i>
                </el-tooltip>
              </span>
            </template>
            <el-select v-model="declareForm.userList[0].JobClasss" placeholder="" clearable size="small" style="width:300px">
              <el-option v-for="(item,index) in JobClasssList" :key="index" :value="item"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="员工属性" prop="userList[0].EmployeeAttribute">
            <el-select v-model="declareForm.userList[0].EmployeeAttribute" placeholder="" clearable size="small" style="width:300px">
              <el-option value="长期工"></el-option>
              <el-option value="临时工"></el-option>
              <el-option value="日结工"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showDeclare = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmSubmitDeclare" size="small" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>


    <el-dialog title="单笔签约" :visible.sync="showSigning" width="1060px">
      <el-form :model="signingForm" :inline="true" ref="signingForm" :rules="importRules" label-width="130px">
        <el-form-item label="项目名称" prop="ObjName">
          <el-select v-model="signingForm.ObjName" placeholder="" clearable filterable style="width:200px" @change="changePro" size="small">
            <el-option v-for="item in projectList" :key="item.Id" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="签约模板" prop="tempid">
          <el-select v-model="tempNameSingle" placeholder="" clearable filterable style="width:200px" value-key="TempId" :disabled="!signingForm.ObjName" size="small" @change="changeTempSingle">
            <el-option v-for="(item, index) in tempList" :key="index" :label="item.TempName" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同/协议类型" prop="ProtocolType">
          <el-select v-model="signingForm.ProtocolType" value-key="name" placeholder="" clearable filterable size="small" @change="(val) => { changeCont(val, 'signingForm') }" style="width:200px">
            <el-option v-for="(item, index) in contractList2" :key="index" :label="item.name" :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="合同预览" v-if="this.shangTempId">
          <div style="width: 200px;">
            <el-button type="text" class="blueName cp" @click="review">合同预览</el-button>
          </div>
        </el-form-item>
        <el-form-item label="姓名" prop="list[0].name">
          <el-input v-model="signingForm.list[0].name" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="电话" prop="list[0].PhoneNum">
          <el-input v-model.trim="signingForm.list[0].PhoneNum" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="身份证" :prop="contractType != 11 ? 'list[0].StrIdCard' : ''">
          <el-input v-model.trim="signingForm.list[0].StrIdCard" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="员工签约主体" prop="ContractSubject">
          <el-select v-model="signingForm.ContractSubject" placeholder="" clearable filterable style="width:200px" size="small" @change="(val) => { changeLeg(val, 'signingForm') }">
            <el-option v-for="(item, index) in legList" :key="index" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="法人" prop="LegalPer" v-if="contractType != 11">
          <el-input v-model="signingForm.LegalPer" readonly style="width:200px" disabled size="small"></el-input>
        </el-form-item>
        <el-form-item label="注册地址" prop="RegisterAddress" v-if="contractType != 11">
          <el-input v-model="signingForm.RegisterAddress" readonly style="width:200px" disabled size="small"></el-input>
        </el-form-item>

        <el-form-item :label="jobNameLabel" prop="list[0].JobName" v-if="contractType != 1 && contractType != 9 && contractType != 10 && contractType != 11 && contractType != 12 && contractType">
          <el-input v-model="signingForm.list[0].JobName" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="工作地点(区域)" prop="WorkSite" v-if="contractType == 5 || contractType == 6">
          <el-input v-model="signingForm.WorkSite" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="学校全称" prop="SchoolName" v-if="contractType == 3 || contractType == 9">
          <el-input v-model="signingForm.SchoolName" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="学生专业" prop="StudentMajor" v-if="contractType == 9">
          <el-input v-model="signingForm.StudentMajor" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="入职日期" :prop="contractType == 8 || contractType == 9 || contractType == 10 ? '' : 'list[0].DtEntryBdate'" v-if="contractType != 11 && contractType != 12">
          <el-date-picker type="date" placeholder="" v-model="signingForm.list[0].DtEntryBdate" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>

        <el-form-item label="文化程度" prop="list[0].StrEduLvl" v-if="contractType && contractType < 8">
          <el-input v-model="signingForm.list[0].StrEduLvl" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="联系地址" prop="list[0].EmpContactAddress" v-if="contractType && contractType < 8">
          <el-input v-model="signingForm.list[0].EmpContactAddress" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="客户单位全称">
          <el-input v-model="signingForm.list[0].ClientFullName" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item :label="contractType != 9 || contractType != 10 ? '合同起始时间' : '协议起始时间'" prop="ContractStartTime" v-if="contractType != 9 && contractType != 10 && contractType != 11 && contractType">
          <el-date-picker type="date" placeholder="" v-model="signingForm.ContractStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item :label="contractType != 9 || contractType != 10 ? '合同时长（年）' : '协议时长（年）'" v-if="contractType != 9 && contractType != 10 && contractType != 11 && contractType != 12 && contractType != 13 && contractType">
          <el-input type="number" v-model="ContractTime" @blur="getContractEndDate('signingForm')" style="width:200px" size="small" :disabled="!signingForm.ContractStartTime"></el-input>
        </el-form-item>
        <el-form-item :label="contractType != 9 || contractType != 10 ? '合同结束时间 （可编辑更改）' : '协议结束时间 （可编辑更改）'" prop="ContractEndTime" v-if="contractType != 9 && contractType != 10 && contractType != 11 && contractType != 13 && no != 22 && contractType">
          <el-date-picker type="date" placeholder="" v-model="signingForm.ContractEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="合同结束时间" v-if="contractType == 13 || no == 22">
          <el-input v-model="noDateTxt" style="width:200px" size="small" readonly disabled></el-input>
        </el-form-item>
        <el-form-item label="试用期起始时间" prop="TrialPeriodStartTime" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
          <el-date-picker type="date" placeholder="" v-model="signingForm.TrialPeriodStartTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>
        <el-form-item label="试用期时长（月）" prop="TrialMonth" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
          <el-input type="number" v-model="signingForm.TrialMonth" style="width:200px" size="small" :disabled="!signingForm.TrialPeriodStartTime" @blur="getEndDate('signingForm')"></el-input>
        </el-form-item>
        <el-form-item label="试用期结束时间（可编辑更改）" prop="TrialPeriodEndTime" v-if="contractType == 1 || contractType == 2 || contractType == 5 || contractType == 7">
          <el-date-picker type="date" placeholder="" v-model="signingForm.TrialPeriodEndTime" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>

        <el-form-item :label="contractType == 8 ? '终止（解除）劳动合同时间' : '终止（解除）协议时间'" prop="TimeLaborContract" v-if="contractType == 8 || contractType == 9 || contractType == 10 || contractType == 12 || contractType == 13">
          <el-date-picker type="date" placeholder="" v-model="signingForm.TimeLaborContract" value-format="yyyy-MM-dd" style="width:200px" size="small" @blur="changeTimeLaborContract('signingForm')"></el-date-picker>
        </el-form-item>

        <el-form-item label="工作时长(年)" prop="WorkingYear" v-if="contractType == 8 || contractType == 13">
          <el-input v-model="signingForm.WorkingYear" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="工作时长(月)" prop="WorkingMonth" v-if="contractType == 8 || contractType == 13">
          <el-input v-model="signingForm.WorkingMonth" style="width:200px" size="small"></el-input>
        </el-form-item>
        <el-form-item label="工作时长(天)" prop="WorkingDay" v-if="contractType == 8 || contractType == 13">
          <el-input v-model="signingForm.WorkingDay" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item :label="contractType == 8 ? '终止（解除）劳动合同时间（员工联）' : '终止（解除）协议时间（员工联）'" prop="TimeLaborContractStaff" v-if="contractType == 8 || contractType == 9 || contractType == 10 || contractType == 12 || contractType == 13">
          <el-date-picker type="date" placeholder="" v-model="signingForm.TimeLaborContractStaff" value-format="yyyy-MM-dd" style="width:200px" size="small"></el-date-picker>
        </el-form-item>

        <el-form-item label="银行卡号" v-if="contractType != 11 && contractType != 12 && contractType != 13">
          <el-input v-model="signingForm.list[0].Bankcard" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="开户银行" v-if="contractType != 11 && contractType != 12 && contractType != 13">
          <el-input v-model="signingForm.list[0].DepositBank" style="width:200px" size="small"></el-input>
        </el-form-item>


        <el-form-item label="发薪日" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13">
          <el-input v-model="signingForm.PayDay" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="工资标准方式" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13">
          <el-select v-model="signingForm.MeansOfPayments" placeholder="" clearable filterable size="small" style="width:200px">
            <el-option value="0" label="固定工资"></el-option>
            <el-option value="1" label="基本工资+绩效工资"></el-option>
            <el-option value="2" label="计件工资"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="工资" v-if="contractType != 8 && contractType != 9 && contractType != 10 && contractType != 12 && contractType != 13">
          <el-input v-model="signingForm.Yuan" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="备注1" v-if="contractType == 11">
          <el-input v-model="signingForm.list[0].Remark1" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="备注2" v-if="contractType == 11">
          <el-input v-model="signingForm.list[0].Remark2" style="width:200px" size="small"></el-input>
        </el-form-item>

        <el-form-item label="备注3" v-if="contractType == 11">
          <el-input v-model="signingForm.list[0].Remark3" style="width:200px" size="small"></el-input>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showSigning = false" size="small">取 消</el-button>
        <el-button type="primary" v-preventReClick style="margin-left:10px;" @click="confirmSign" size="small" :loading="isBtnLoading">提 交</el-button>
      </span>
    </el-dialog>

    <el-dialog title="合同预览" :visible.sync="showPreview" width="90%">

      <div v-loading="previewLoading" element-loading-text="加载中···" element-loading-spinner="el-icon-loading" v-if="previewLoading" style="height:500px"></div>
      <div v-if="previewLoading" style="height:500px"></div>
      <iframe style="width: 100%;height:80vh" :src="previewUrl"></iframe>
    </el-dialog>
  </div>
</template>

<script>
  import xz from "../../common";
  import moment from 'moment';
  import "moment-precise-range-plugin"
  export default {
    data() {
      var validatetInsuranceTime = (rule, value, callback) => {
        if (!this.declareForm.Insurance.InsuranceStartTime) {
          callback(new Error("请选择保障开始时间"));
        } else if (!this.declareForm.Insurance.InsuranceStartTime) {
          callback(new Error("请选择保障结束时间"));
        } else {
          callback();
        }
      };
      var validatetPolicy = (rule, value, callback) => {
        if (!this.policy) {
          callback(new Error("请选择可参保保单"));
        } else {
          callback();
        }
      };
      var validatetJobTips = (rule, value, callback) => {
        if (!this.signingForm.list[0].JobName) {
          if (this.jobNameLabel == '工作岗位(A管理类、B技术类、C操作类)' || this.jobNameLabel == '工作岗位(A管理、B技术、C操作)') {
            callback(new Error("请输入字母：A或B或C"));
          } else {
            callback(new Error("请输入工作岗位"));
          }

        } else {
          callback();
        }
      };
      return {
        roletype: localStorage.loginRoletype,
        empQuery: {
          strExcelPath: '',
          intExcelLine: ''
        },
        dtlForm: {
          "StrExcelPath": "",
          "IntExcelLine": null,
          "GdUserId": "",
          "StrSrvCent": "",
          "StrBlCmp": "",
          "StrObjName": "",
          "SubProject": null,
          "StrProjectType": "",
          "StrObjInstName": "",
          "StrUserName": "",
          "IntSerialNumber": null,
          "StrFileNo": "",
          "StrTmpProject": null,
          "StrDepName": "",
          "StrJobInf": null,
          "StrEmpName": "",
          "StrIdCard": "",
          "StrPolitical": "",
          "DtIcCareEdate": null,
          "StrCityzenType": "",
          "StrPhoneNum": "",
          "StrContName": null,
          "StrContTel": null,
          "StrNationClass": "",
          "StrNativePlace": "",
          "StrNativeAddr": "",
          "StrAddr": "",
          "StrEduLv": "",
          "StrInsuranceType": "",
          SocialInsuranceAccount: '',
          ProvidentFundAccount: '',
          SocialInsuranceNumber: '',
          ProvidentFundNumber: '',
          ProvidentFundRate: '',
          LowestSalary: '',
          "DtInsuranceDate": "",
          "StrMedicalCard": null,
          "DtEntryBdate": "",
          "StrContractType": "",
          "IntContractNum": null,
          "StrContractBedate": null,
          "DtProbationEdate": null,
          "DtContractBtime": "",
          "DtContractTime": "",
          "StrWorkState": "",
          "CustomerName": "",
          "InsureJobClass": "",
          "IsFullTime": "",
          "DtDepartureDate": "",
          "DtRealDepartureDate": "",
          "StrBankCard": "",
          "StrBankName": "",
          "StrWithdrawal": "",
          "StrInCity": "",
          "StrOutsideCity": "",
          "StrOther": "",
          "StrPetype": "",
          "StrPeres": "",
          "StrEmpUsrStatus": null,
          "DtInjuryBdate": null,
          DtInjuryEndDate: null,
          MedicineBeginDate: null,
          MedicineEndDate: null,
          ProcessingPace: null,
          CSInfo: null,
          CSPace: null,
          FinishMajor: null,
          FinishSchoolTime: null,
          FinishSchoolName: null,
          Major: null,
          "StrDisabilityLevel": null,
          "DtInjuryEdate": null,
          "StrBlacklist": null,
          "StrBlacklistReason": null,
          "StrRemark": null,
          "Sctjr": null,
          "Gsqd": null,
          "Gsqdtjr": null,
          "Wbqd": null,
          "Wbqdtjr": null,
          "Qtqk": "",
          "DtInsertDate": "",
          "PushTime": "",
          "PushRemark": "",
          "MarriageState": "",
          "IsCheckUp": "",
          "OutCompanyReason": "",
          "SchoolName": "",
          "InSchoolTime": "",
          "OutSchoolTime": "",
          "ContractInfo": null,
          "ThreeBeginTime": "",
          "ThreeEndTime": "",
          "FrontCardIdUrl": null,
          "VersoCardIdUrl": null,
          "BankCardUrl": null,
          "ContractUrl": null,
          "Extend": null,
          "Json": "",
          "CompanyAge": "",
          "OutCompanyOptionTime": null,
          "SignJob": null,
          "InsureJob": null,
          "ContractJson": null,
          "OtherUrl": [],
          "IdCardIssUing": null,
          "ReimbursementDate": null,
          ContractCompanyName: '',
          SalaryCompanyName: '',
          InvoiceCompanyNameInSide: '',
          OutCompanyReason: '',
        },
        rule: {
          StrObjName: {
            required: true,
            message: "请选择项目",
            trigger: "change",
          },
          StrProjectType: {
            required: true,
            message: "请选择项目类别",
            trigger: "change",
          },
          StrOutsideCity: {
            required: true,
            message: "请选择招聘岗位",
            trigger: "change",
          },
          StrInCity: {
            required: true,
            message: "请选择招聘岗位类别",
            trigger: "change",
          },
          StrOther: {
            required: true,
            message: "请选择临时工",
            trigger: "change",
          },
          StrEmpName: {
            required: true,
            message: "请输入姓名",
            trigger: "blur",
          },
          StrIdCard: {
            required: true,
            message: "请输入身份证号码",
            trigger: "blur",
          },
          StrPhoneNum: {
            required: true,
            message: "请输入联系方式",
            trigger: "blur",
          },
          StrWorkState: {
            required: true,
            message: "请选择在离职状态",
            trigger: "change",
          },
          CustomerName: {
            required: true,
            message: "请输入客户单位全称",
            trigger: "blur",
          },
          DtDepartureDate: {
            required: true,
            message: "请选择在离职日期",
            trigger: "change",
          },
          DtEntryBdate: {
            required: true,
            message: "请选择用工之日",
            trigger: "change",
          },
          StrBlCmp: {
            required: true,
            message: "请选择开票公司全称",
            trigger: "change",
          },
          times: {
            required: true,
            message: "请选择次数",
            trigger: "change",
          },
        },
        loading: false,
        imageUrl: '',
        contractList: [],
        projectList: [], // 项目列表
        // 项目名称列表参数
        proNameQuery: {
          searchVal: '',
          pageSize: 100000000,
          pageNum: 1
        },
        memberList: [],
        departMemberQuery: {
          keyword: '',
          strWorkState: '在职',
          currpage: 1,
          perpage: 100000
        },
        JobList: [],
        legList: [],
        index: 0,
        imgHead: this.$store.state.EMP.imgPath,
        docHead: this.$store.state.EMP.docPath,
        isOver: false,
        isBtnLoading: false,
        ContractJson: [], //合同信息
        itemInfo: {
          times: null,
          type: '',
          DtEntryBdate: '',
          DtContractBtime: '',
          DtContractTime: '',
          DtProbationEdate: '',
          fileUrl: [],
        },
        showAddContract: false,
        fileList: [],
        // 民族
        nationList: [],
        type: '',
        activeName: '1',
        type: '',
        IsFlow: false, //是否是流程中的数据
        gdststusID: '',
        remarkInfo: null,
        showDeclare: false,
        declareForm: { //报增减表单
          Insurance: {
            BusinessType: 1, //1报增 0 报减
            InsuranceId: '', //险种id
            ProjectName: '', //项目名称
            OrderNum: '', //订单号
            Projectid: '', //项目id
            InsuranceStartTime: '', //保险期限
            InsuranceEndTime: '',
          },
          IsRPA:1,
          userList: [{
            MainlinsuredName: '', //姓名
            MainlinsuredCardId: '', //证件号
            Idtype: '', //证件类型
            MainlinsuredPhone: '', //手机号码
            JobName: '', //岗位名称
            JobClasss: '', //职业类别
            EmployeeAttribute: '', //员工属性
          }]
        },
        declareRules: {
          'Insurance.InsuranceStartTime': {
            required: true,
            validator: validatetInsuranceTime,
            trigger: "change",
          },
          'policy': {
            required: true,
            validator: validatetPolicy,
            trigger: "change",
          },
          'Insurance.Projectid': {
            required: true,
            message: "请选择项目",
            trigger: "change",
          },
          'userList[0].MainlinsuredName': {
            required: true,
            message: "请输入被保险人姓名",
            trigger: "blur",
          },
          'userList[0].Idtype': {
            required: true,
            message: "请选择被证件类型",
            trigger: "change",
          },
          'userList[0].MainlinsuredCardId': {
            required: true,
            message: "请输入证件号码",
            trigger: "blur",
          },
          'userList[0].MainlinsuredPhone': {
            required: true,
            message: "请输入被保险人手机号码",
            trigger: "blur",
          },
          'userList[0].JobName': {
            required: true,
            message: "请输入岗位",
            trigger: "blur",
          },
          'userList[0].JobClasss': {
            required: true,
            message: "请选择职业类别",
            trigger: "change",
          },
          'userList[0].EmployeeAttribute': {
            required: true,
            message: "请选择员工属性",
            trigger: "change",
          },
        },
        JobClasssList: ['1-4类', '5类'],
        JobNameTip: '',
        JobClasssTip: '',
        proName: '',
        policy: '',
        insureList: [],
        policyList: [],
        showSigning: false, //单笔签约 弹窗
        signingForm: {
          ContractSubject: '', //主体
          tempid: '',
          IsRPA:1,
          ObjName: '', //项目名称
          ContractSubject: '', //签约主体
          LegalPer: '', //法人
          RegisterAddress: '', //注册地址
          ContractStartTime: '', //合同起始时间
          ContractEndTime: '', //合同结束时间
          TrialPeriodStartTime: '', //试用期起始时间
          TrialPeriodEndTime: '', //试用期结束时间
          TrialMonth: '', //试期月份
          WorkSite: '', //工作地点
          SchoolName: '', //学校
          WorkingYear: '', //工作时长(年)
          WorkingMonth: '', //工作时长(月)
          WorkingDay: '', //工作时长(天)
          TimeLaborContract: '', //终止（解除）劳动合同时间
          TimeLaborContractStaff: '', //终止（解除）劳动合同时间（员工联）
          MeansOfPayments: '', //工资标准方式
          PayDay: '',
          Yuan: '',
          list: [{
            name: '',
            PhoneNum: '',
            StrIdCard: '',
            DtEntryBdate: '', //入职日期
            JobName: '', //岗位
            StrEduLvl: '', //文化程度
            ClientFullName: '',
            EmpContactAddress: '', //联系地址
            Bankcard: '', //银行卡号
            DepositBank: '', //开户银行
            Remark1: '',
            Remark2: '',
            Remark3: '',
          }]
        },
        tempList: [], //模板列表
        shangTempId: '', //预览合同ID
        showPreview: false, //合同预览弹窗
        previewLoading: false,
        previewUrl: '',
        contractType: '',
        no: '',
        tempNameSingle: '', //模板名称  单笔签约
        contractList2: this.$store.state.EMP.contractList, //合同/协议列表
        ContractTime: '', //合同时长
        importRules: {
          ObjName: {
            required: true,
            message: '请选择项目',
            trigger: 'change'
          },
          tempid: {
            required: true,
            message: '请选择签约模板',
            trigger: 'change'
          },
          ContractSubject: {
            required: true,
            message: '请选择主体',
            trigger: 'change'
          },
          LegalPer: {
            required: true,
            message: '请选择法人',
            trigger: 'change'
          },
          RegisterAddress: {
            required: true,
            message: '请选择注册地址',
            trigger: 'change'
          },
          ProtocolType: {
            required: true,
            message: '请选择合同/协议类型',
            trigger: 'change'
          },
          'list[0].DtEntryBdate': {
            required: true,
            message: '请选择入职日期',
            trigger: 'change'
          },
          ContractStartTime: {
            required: true,
            message: '请选择合同起始时间',
            trigger: 'change'
          },
          ContractEndTime: {
            required: true,
            message: '请选择合同结束时间',
            trigger: 'change'
          },
          TrialPeriodStartTime: {
            required: true,
            message: '请选择试用期起始时间',
            trigger: 'change'
          },
          TrialPeriodEndTime: {
            required: true,
            message: '请选择试用期结束时间',
            trigger: 'change'
          },
          TrialMonth: {
            required: true,
            message: '请选择合同起始时间',
            trigger: 'blur'
          },
          'list[0].name': {
            required: true,
            message: '请输入姓名',
            trigger: 'blur'
          },
          'list[0].PhoneNum': {
            required: true,
            message: '请输入电话',
            trigger: 'blur'
          },
          'list[0].StrIdCard': {
            required: true,
            message: '请输入身份证',
            trigger: 'blur'
          },
          'list[0].JobName': {
            required: true,
            validator: validatetJobTips,
            trigger: 'blur'
          },
          SchoolName: {
            required: true,
            message: '学校全称',
            trigger: 'blur'
          },
          WorkSite: {
            required: true,
            message: '请输入工作地点(区域)',
            trigger: 'blur'
          },
          PayDay: {
            required: true,
            message: '请输入发薪日',
            trigger: 'blur'
          },
          MeansOfPayments: {
            required: true,
            message: '请选择工资标准方式',
            trigger: 'blur'
          },
          Yuan: {
            required: true,
            message: '请输入工资',
            trigger: 'blur'
          },
          WorkingYear: {
            required: true,
            message: '请输入工作时长(年)',
            trigger: 'blur'
          },
          WorkingMonth: {
            required: true,
            message: '请输入工作时长(月)',
            trigger: 'blur'
          },
          WorkingDay: {
            required: true,
            message: '请输入工作时长(天)',
            trigger: 'blur'
          },
          TimeLaborContract: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间',
            trigger: 'change'
          },
          TimeLaborContractStaff: {
            required: true,
            message: '请选择终止（解除）劳动合同/协议时间（员工联）',
            trigger: 'change'
          },
          StudentMajor: {
            required: true,
            message: '请输入学生专业',
            trigger: 'blur'
          },
          'list[0].StrEduLvl': {
            required: true,
            message: '请输入文化程度',
            trigger: 'blur'
          },
          'list[0].EmpContactAddress': {
            required: true,
            message: '请输入联系地址',
            trigger: 'blur'
          },
        },
      }
    },
    created() {
      if (this.$route.query.strExcelPath != undefined && this.$route.query.strExcelPath) {
        this.empQuery.strExcelPath = this.$route.query.strExcelPath;
        this.empQuery.intExcelLine = this.$route.query.intExcelLine;
        this.PersonInfo();
      }
      if (this.$route.query.type != undefined && this.$route.query.type) {
        this.type = this.$route.query.type;
        this.isOver = true;
      }
      if (this.$route.query.gdststusID != undefined && this.$route.query.gdststusID) {
        this.gdststusID = this.$route.query.gdststusID;
        this.dtlForm.gdststusID = this.$route.query.gdststusID;
        this.PersonInfoFlow();
      }
      this.getProNameList();
      this.getMemberList();
      this.getlegalsubjectlist();
      this.getdictdatalistbyid();
    },
    methods: {
      // 获取项目列表
      getProNameList() {
        xz.getplancomrecordprojectlist(this.proNameQuery, localStorage.loginRoletype).then(res => {
          // console.log('项目名称列表', res)
          if (res.status == 'ok') {
            this.projectList = res.data
          } else {
            this.projectList = []
          }
        })
      },
      //获取民族列表
      getdictdatalistbyid() {
        xz.getdictdatalistbyid('253').then(res => {
          if (res.status == 'ok') {
            this.nationList = res.data.retList
          } else {
            this.nationList = []
          }
        })
      },
      // 获取员工列表
      getMemberList() {
        xz.getauthUserInfoByorgancode(this.departMemberQuery).then(res => {
          // console.log('员工', res)
          if (res.status == 'ok') {
            this.memberList = res.msg
          } else {
            this.memberList = []
          }
        })
      },
      changeTab() {
        if (this.activeName == '0') {
          this.$router.push({
            path: '/rosterEmpDtl',
            query: {
              strExcelPath: this.empQuery.strExcelPath,
              intExcelLine: this.empQuery.intExcelLine
            }
          })
        }
      },
      PersonInfo() {
        this.loading = true;
        xz.PersonInfo(this.empQuery, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.dtlForm = res.info;
            this.IsFlow = res.IsFlow;
            this.loading = false;
            if (res.info.OtherUrl) {
              this.contractList = JSON.parse(res.info.OtherUrl)
            }

            if (res.info.ContractJson) {
              this.ContractJson = JSON.parse(res.info.ContractJson)
              console.log('ContractJson', this.ContractJson)
            } else {
              this.ContractJson = []
            }
            this.wxappgetjoblist();
            this.isOver = true;
            try {
              this.remarkInfo = JSON.parse(res.info.Json)
            } catch {
              this.remarkInfo = null
            }
          } else {
            this.loading = false;
            this.$message.error(res.msg);
            this.isOver = false;
          }
        })
      },
      PersonInfoFlow() {
        this.loading = true;
        let d = {
          gdststusID: this.gdststusID
        }
        xz.PersonInfoFlow(d, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.dtlForm = res.info;
            this.dtlForm.gdststusID = this.$route.query.gdststusID;
            this.IsFlow = res.IsFlow;
            this.loading = false;
            if (res.info.OtherUrl) {
              this.contractList = JSON.parse(res.info.OtherUrl)
            }

            if (res.info.ContractJson) {
              this.ContractJson.push(JSON.parse(res.info.ContractJson)[0])
              console.log('ContractJson', this.ContractJson)
            } else {
              this.ContractJson = []
            }
            if (this.type == 'entryHandel') {
              this.dtlForm.StrWorkState = '在职'
            }
            this.wxappgetjoblist();
            this.isOver = true;
            try {
              this.remarkInfo = JSON.parse(res.info.Json)
            } catch {
              this.remarkInfo = null
            }
          } else {
            this.loading = false;
            this.$message.error(res.msg);
            this.isOver = false;
          }
        })
      },
      wxappgetjoblist() {
        let d = {
          StrPlanstatus: '招聘中', //状态
          JobCategory: '', //岗位类型
          StrprojectName: this.dtlForm.StrObjName, //项目名称
          AgeReqStart: '',
          AgeReqEnd: '',
          Gender: '',
          WorkCityName: '',
          pageNum: 1,
          pageSize: 100
        }
        xz.wxappgetjoblist(localStorage.loginRoletype, d).then(
          (res) => {
            if (res.status == "ok") {
              this.JobList = res.data.retList
            } else {
              this.JobList = [];
            }
          });

        let projectInfoParam = {
          strobjname: this.dtlForm.StrObjName
        }
        xz.GetProjectInfo(localStorage.loginRoletype, projectInfoParam).then(
          (res) => {
            if (res.status == "ok") {
              if (res.data.StrSrvCent != null)
                this.dtlForm.StrSrvCent = res.data.StrSrvCent;
              if (res.data.CustomerName != null)
                this.dtlForm.CustomerName = res.data.CustomerName;
              if (res.data.StrProjectType != null)
                this.dtlForm.StrProjectType = res.data.StrProjectType;
              if (res.data.StrObjInstName != null)
                this.dtlForm.StrObjInstName = res.data.StrObjInstName;
              if (res.data.StrUserName != null)
                this.dtlForm.StrUserName = res.data.StrUserName;
            }
          });
      },
      handleAvatarSuccess(file, fileList, name, type) {
        let formData = new FormData();
        formData.append("action", "save");
        formData.append("pagename", "entimg");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("entPicFile", file.raw, file.raw.name);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            this.dtlForm[name] = res;
            const formData = new FormData();
            formData.append("type", type);
            formData.append("pagename", 'Url');
            formData.append("file", this.imgHead + res);
            console.log("formData", formData);
            xz.distinguishImg(formData).then((r) => {
              if (type == 0) {
                if (r.data.idCard != undefined && r.data.idCard && (this.type == 'entry' || this.type == 'entryHandel')) {
                  this.dtlForm.StrIdCard = r.data.idCard;
                }
                if (r.data.name != undefined && r.data.name && (this.type == 'entry' || this.type == 'entryHandel')) {
                  this.dtlForm.StrEmpName = r.data.name;
                }
                if (r.data.address != undefined && r.data.address) {
                  this.dtlForm.StrNativeAddr = r.data.address;
                }
              } else if (type == 1) {
                if (r.data.no != undefined && r.data.no) {
                  this.dtlForm.StrBankCard = r.data.no;
                  this.dtlForm.StrBankName = r.data.name;
                }
              } else {
                if (r.data.end != undefined && r.data.end) {
                  this.dtlForm.DtIcCareEdate = r.data.end;
                  this.dtlForm.IdCardIssUing = r.data.address;
                }
              }
            });
          } else {
            this.$message("文件上传失败,请稍后再试");
          }
        });
      },
      handleExceed() {
        this.$message.warning(`当前限制最多上传 5 个文件`);
      },
      // 删除附件
      handleFileRemove(file) {
        this.contractList.forEach((e, i) => {
          if (file.uid == e.uid) {
            this.contractList.splice(i, 1)
          }
        });
        console.log(this.contractList);
      },
      // 上传附件
      success_handle(file) {
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            let d = {
              uid: '',
              url: this.docHead + res,
              name: file.name
            }
            this.contractList.push(d)
            // this.fileList = this.itemInfo.fileUrl
          } else {
            // this.dtlForm.OtherUrl = ''
          }
        });
      },
      handleExceed2() {
        this.$message.warning(`当前限制最多上传 5 个文件`);
      },
      // 删除附件
      handleFileRemove2() {
        this.itemInfo.fileUrl = [];
      },
      // 上传附件
      success_handle2(file, fileList) {
        const formData = new FormData();
        formData.append("pagename", "docinf");
        formData.append("action", "save");
        formData.append("userid", Cookies.get("userid-b"));
        formData.append("entid", Cookies.get("userid-b"));
        formData.append("excel", file.raw, file.name);
        console.log("formData", formData, file);
        xz.uploadCert(formData).then((res) => {
          if (res) {
            let d = {
              url: res,
              name: file.name
            }
            this.itemInfo.fileUrl.push(d)
            this.fileList = this.itemInfo.fileUrl
            // console.log('fileList', this.itemInfo.fileUrl)
          } else {
            this.itemInfo.fileUrl = ''
          }
        });
      },
      //识别
      orcType(url,type)
      {
            const formData = new FormData();
            formData.append("type", type);
            formData.append("pagename", 'Url');
            formData.append("file", this.imgHead + url);
            xz.distinguishImg(formData).then((r) => {
              if (type == 0) {
                if (r.data.idCard != undefined && r.data.idCard && (this.type == 'entry' || this.type == 'entryHandel')) {
                  this.dtlForm.StrIdCard = r.data.idCard;
                }
                if (r.data.name != undefined && r.data.name && (this.type == 'entry' || this.type == 'entryHandel')) {
                  this.dtlForm.StrEmpName = r.data.name;
                }
                if (r.data.address != undefined && r.data.address) {
                  this.dtlForm.StrNativeAddr = r.data.address;
                }
              } else if (type == 1) {
                if (r.data.no != undefined && r.data.no) {
                  this.dtlForm.StrBankCard = r.data.no;
                  this.dtlForm.StrBankName = r.data.name;
                }
              } else {
                if (r.data.end != undefined && r.data.end) {
                  this.dtlForm.DtIcCareEdate = r.data.end;
                  this.dtlForm.IdCardIssUing = r.data.address;
                }
              }
            });
      },
      //获取法务主体列表
      getlegalsubjectlist() {
        let data = {
          keyWord: '',
          pageSize: '10000'
        }
        xz.BasicFun(data, 'GetSubjectOfLegalAffairs').then(res => {
          if (res.status == 'ok') {
            this.legList = res.data;
          } else {
            this.legList = [];
          }
        })
      },
      submit() {
        this.$refs.dtlForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            this.dtlForm.ContractJson = this.ContractJson;
            if (this.contractList.length > 0) {
              let d = JSON.parse(JSON.stringify(this.contractList))
              this.dtlForm.OtherUrl = JSON.stringify(d)
            }
            if (this.remarkInfo) {
              this.dtlForm.Json = JSON.stringify(this.remarkInfo)
            }
            let pagename = this.type == 'entry' ? 'AddPerson' : this.IsFlow ? 'UpdatePersonFlow' : 'UpdatePerson';
            xz.UpdatePerson(this.dtlForm, this.roletype, pagename).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功！');
                this.isBtnLoading = false;
              } else {
                this.$message.error(res.msg);
                this.isBtnLoading = false;
              }
            })
          }
        })
      },
      backHandle() {
        window.close()
      },
      addContract() {
        this.itemInfo = {
          times: null,
          type: '',
          DtEntryBdate: '',
          DtContractBtime: '',
          DtContractTime: '',
          DtProbationEdate: '',
          fileUrl: [],
        }
        this.type = 'add'
        this.showAddContract = true;
        // this.ContractJson.push
      },
      edit(row, index) {
        this.type = 'edit';
        this.index = index;
        this.itemInfo = row;
        if (this.itemInfo.fileUrl == '' || this.itemInfo.fileUrl == null) {
          this.itemInfo.fileUrl = []
        } else {
          this.fileList = this.itemInfo.fileUrl
        }
        this.showAddContract = true;
      },
      del(index) {
        this.ContractJson.splice(index, 1);
        this.UpdateContract();
      },
      confirmAddContract() {
        if (this.itemInfo.times) {
          if (this.type == 'edit') {
            this.ContractJson[this.index] = this.itemInfo;
          } else {
            this.ContractJson.push(this.itemInfo);
            this.OfflineSigning();
          }
          this.UpdateContract();
        } else {
          this.$message.warning('请选择次数')
        }
      },
      OfflineSigning() {
        let d = {
          Id: '',
          Name: this.dtlForm.StrEmpName,
          PhoneNum: this.dtlForm.StrPhoneNum,
          StrObjName: this.dtlForm.StrObjName, //项目名称
          StrIdCard: this.dtlForm.StrIdCard, //身份证
          TempType: '用工协议', //签约类型
          ContractSubject: this.dtlForm.StrBlCmp, //员工签约主体
          SignatureTime: this.itemInfo.DtContractBtime, //合同签约时间
          ContractStartTime: this.itemInfo.DtContractBtime, //合同开始时间
          ContractEndTime: this.itemInfo.DtContractTime, //合同结束时间
          dtEntryBDate: this.dtlForm.DtInsertDate, //入职日期
          AttachUrl: this.dtlForm.fileUrl, //合同附件
        }
        xz.addOfflineSigning(d, this.roletype).then(res => {

        })
      },
      UpdateContract() {
        let d = {
          ContractJson: this.ContractJson,
          StrExcelPath: this.empQuery.strExcelPath,
          IntExcelLine: this.empQuery.intExcelLine,
        }
        this.isBtnLoading = true;
        let pagename = this.IsFlow ? 'UpdateContractFlow' : 'UpdateContract';
        xz.UpdateContract(d, this.roletype, pagename).then(res => {
          if (res.status == 'ok') {
            this.$message.success('保存成功');
            this.showAddContract = false;
            this.isBtnLoading = false;
          } else {
            this.$message.error(res.msg);
            this.isBtnLoading = false;
          }
        })
      },
      down(item) {
        let path = '';
        if (item.uid != undefined && item.uid) {
          path = this.$store.state.EMP.docPath + item.url;
        } else {
          path = this.$store.state.EMP.imgPath + item.url;
        }
        const aTag = document.createElement('a')
        aTag.href = path;
        aTag.download = item.name;
        aTag.click();
      },
      addInsure() {
        if (this.insureList.length == 0) {
          this.getInsurancManageByUserid()
        }
        this.showDeclare = true;
        this.clearForm()
      },
      //取自己可取到险种
      getInsurancManageByUserid() {
        let d = {
          pageNum: 1,
          pageSize: 100
        }
        xz.getInsurancManageByUserid(d, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.insureList = res.data.list;
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      changeInsuranceId(val) {
        this.getPolicyList(val);
      },
      //获取可参保时间段列表
      getPolicyList(id) {
        let data = {
          insurable: 1,
          pageNum: 1,
          InsuranceId: id,
          pageSize: 1000,
        }
        xz.getOrderPolicyManageList(data, this.roletype).then(res => {
          if (res.status == 'ok') {
            this.policyList = res.data.list;
          } else {
            this.policyList = []
          }
        })
      },
      policyChange(val) {
        this.declareForm.Insurance.OrderNum = val.OrderCode;
        this.declareForm.Insurance.InsuranceStartTime = val.CoverStartTime;
        this.declareForm.Insurance.InsuranceEndTime = val.CoverEndTime;
      },
      //查看资料详情
      getTipDtl() {
        let routeUrl = this.$router.resolve({
          path: "/model",
        });
        window.open(routeUrl.href, "_blank");
      },
      //选择项目
      proChange(val) {
        this.declareForm.Insurance.ProjectName = val.StrprojectName;
        this.declareForm.Insurance.Projectid = val.Projectid;
      },
      clearForm() {
        this.policy = '';
        let pro = {
          StrprojectName: '',
          Projectid: null
        };
        if (this.dtlForm.StrObjName) {
          pro = this.projectList.find(e => e.StrprojectName == this.dtlForm.StrObjName)
          console.log(pro)
          this.proName = pro;
        }
        this.declareForm = { //报增减表单
          Insurance: {
            BusinessType: 1,
            InsuranceId: '', //险种id
            ProjectName: pro.StrprojectName, //项目名称
            OrderNum: '', //订单号
            Projectid: pro.Projectid, //项目id
            InsuranceStartTime: '', //保险期限
            InsuranceEndTime: '',
          },
          IsRPA:1,
          userList: [{
            MainlinsuredName: this.dtlForm.StrEmpName, //姓名
            MainlinsuredCardId: this.dtlForm.StrIdCard, //证件号
            Idtype: '身份证', //证件类型
            MainlinsuredPhone: this.dtlForm.StrPhoneNum, //手机号码
            JobName: this.dtlForm.StrJobInf, //岗位名称
            JobClasss: '', //职业类别
            EmployeeAttribute: '', //员工属性
          }]
        }
      },
      //确认报增/报减
      confirmSubmitDeclare() {
        this.$refs["declareForm"].validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.reportAddApprov(this.declareForm, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.$message.success('保存成功！');
                this.isBtnLoading = false;
                this.showDeclare = false;
                this.clearForm();
                this.$refs['declareForm'].resetFields();
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg);
              }
            })
          }
        })
      },
      addEleSign() {
        this.signingForm.ObjName = this.dtlForm.StrObjName;
        this.signingForm.list[0].name = this.dtlForm.StrEmpName;
        this.signingForm.list[0].StrIdCard = this.dtlForm.StrIdCard;
        this.signingForm.list[0].PhoneNum = this.dtlForm.StrPhoneNum;
        this.signingForm.list[0].EmpContactAddress = this.dtlForm.StrAddr;
        this.signingForm.list[0].StrEduLvl = this.dtlForm.StrEduLv;
        this.changePro(this.signingForm.ObjName);
        this.showSigning = true;
      },
      changePro(val) {
        this.signingForm.tempid = ''
        if (val) {
          xz.templatesByProjectList(val, this.roletype).then(res => {
            if (res.status == 'ok') {
              this.tempList = res.data.tempList;
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      //单笔签约选择模板
      changeTempSingle(val) {
        this.tempNameSingle = val.TempName;
        this.signingForm.tempid = val.TempId;
        this.shangTempId = val.shangTempId;
      },
      //选择合同/协议
      changeCont(val, list) {
        this[list].ProtocolType = val.name;
        this.contractType = val.val;
        this.jobNameLabel = val.jobNameLabel;
        this.no = val.no;
      },
      review() {
        xz.getTempCombined(this.shangTempId, this.roletype).then(res => {
          if (res.status == 'ok') {
            let url = res.data.content;
            let base64 = url.toString()
            let byteCharacters = atob(
              base64.replace(/^data:image\/(png|jpeg|jpg);base64,/, "")
            )
            let byteNumbers = new Array(byteCharacters.length)
            for (let i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i)
            }
            let byteArray = new Uint8Array(byteNumbers)
            let blob = new Blob([byteArray], {
              type: `application/pdf`
            })
            this.previewUrl = URL.createObjectURL(blob);
            this.showPreview = true;
          } else {
            this.$message.error('获取合同失败')
          }
        })
      },
      //选择主体
      changeLeg(val, list) {
        if (val) {
          xz.getLegalSubjec(val).then(res => {
            if (res.status == 'ok') {
              this.$set(this[list], 'LegalPer', res.data.LegalPerson)
              this.$set(this[list], 'RegisterAddress', res.data.RegisteredAddress.indexOf('$$') > -1 ? res.data.RegisteredAddress.replace('$$', '') : res.data.RegisteredAddress)
            } else {
              this.$message.error('获取主体信息出错')
            }
          })
        } else {
          this.$set(this[list], 'LegalPer', '')
          this.$set(this[list], 'RegisterAddress', '')
        }
      },
      getContractEndDate(list) {
        if (this.ContractTime >= 1) {
          this[list].ContractEndTime = moment(this[list].ContractStartTime).add(this.ContractTime, 'years').format('YYYY-MM-DD');
          this[list].ContractEndTime = moment(this[list].ContractEndTime).subtract(1, 'days').format('YYYY-MM-DD');
        }
      },
      getEndDate(list) {
        if (this[list].TrialMonth > 0) {
          this[list].TrialPeriodEndTime = moment(this[list].TrialPeriodStartTime).add(this[list].TrialMonth, 'months').format('YYYY-MM-DD');
          this[list].TrialPeriodEndTime = moment(this[list].TrialPeriodEndTime).subtract(1, 'days').format('YYYY-MM-DD');
        } else {
          this[list].TrialPeriodEndTime = this[list].TrialPeriodStartTime
        }
      },
      //计算工作时长
      changeTimeLaborContract(list) {
        let m1 = this[list].list[0].DtEntryBdate + ' 00:00:00';
        let m2 = this[list].TimeLaborContract + ' 00:00:00';
        let diff = moment.preciseDiff(m1, m2, true);
        console.log(diff)
        this[list].WorkingYear = diff.years;
        this[list].WorkingMonth = diff.months;
        this[list].WorkingDay = diff.days + 1;
      },
      confirmSign() {
        this.$refs.signingForm.validate((valid) => {
          if (valid) {
            this.isBtnLoading = true;
            xz.submitESigningInfo(this.signingForm, this.roletype).then(res => {
              if (res.status == 'ok') {
                this.isBtnLoading = false;
                this.$message.success('保存成功！');
                this.showSigning = false;
              } else {
                this.isBtnLoading = false;
                this.$message.error(res.msg)
              }
            })
          }
        })
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 0px 16px 16px;
    margin-bottom: 16px;
  }

  .dtlBox {
    padding-top: 8px;
  }

  .Reititle {
    font-size: 16px;
    font-weight: bold;
    margin-bottom: 15px;
  }

  .titleLine {
    font-size: 20px;
    color: #F59A23;
    margin-right: 3px;
  }

  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }

  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }

  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    width: 50px;
    height: 50px;
    line-height: 50px;
    text-align: center;
  }

  .avatar {
    width: 50px;
    height: 50px;
    display: block;
  }

  .btn_box {
    display: flex;
    justify-content: center;
    margin-top: 30px;
  }

  .JobClasssTip {
    color: red;
    text-decoration: underline;
  }
</style>
<style>
  .page_rosterEmpEdit .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_rosterEmpEdit .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_rosterEmpEdit .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_rosterEmpEdit .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_rosterEmpEdit .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_rosterEmpEdit .dtlBox .el-form-item {
    margin-bottom: 10px;
  }

  .page_rosterEmpEdit .dtlBox .el-form-item__error {
    top: 34px;
  }


  .long .el-form-item__content {
    min-width: 1000px !important;
  }

  .dtlItem .el-form-item {
    margin-bottom: 0px;
  }
</style>